import { useState } from "react";
import CambiarContraseña from "../../page/login/CambiarContraseña";
import RestPrivateAntesala from "../../../helpers/RestPrivateApi";
import Alerts from "../../components/Alerts/Alerts";
import { useNavigate, useParams } from "react-router-dom";

const ContraseñaController = () => {
  const navigation = useNavigate();
  const { token } = useParams();
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({
    password: "",
    confirm_password: "",
  });

  const onClick = async (e) => {
    switch (e.target.name) {
      case "enviar":
        {
          setLoading(true);

          if (
            form.password.trim() == "" ||
            form.confirm_password.trim() == ""
          ) {
            return Alerts({
              msg: "Alert",
              title: "Todos los campos son obligatorios",
              code: "401",
              type: "error",
            });
          }
          let dataForm = new FormData();
          dataForm.append("password", form.password);
          dataForm.append("repeat_password", form.confirm_password);
          dataForm.append("token", token);

          const response = await RestPrivateAntesala({
            method: "post",
            url: "/auth/recuperar-contraseña",
            formData: dataForm,
            setLoading: setLoading,
          });

          if (response.status == 201 || response.status == 200) {
            Alerts({
              msg: "Alert",
              title: response.data.msg,
              code: "401",
              type: "success",
            });

            return navigation("/login");
          } else {
            Object.keys(response.data.msg).map((key) => {
              if (
                response.data.msg[key][0] == "The email has already been taken."
              ) {
                return Alerts({
                  msg: "Warning",
                  title: "El email ya se encuentra registrado",
                  code: "201",
                  type: "error",
                });
              } else {
                return Alerts({
                  msg: "Warning",
                  title: "Ocurrio un error vuelve a intentarlo mas tarde",
                  code: "201",
                  type: "error",
                });
              }
            });
          }
        }
        break;

      default:
        break;
    }
  };

  const onChange = (e) => {
    switch (e.target.name) {
      case "password":
      case "confirm_password":
        {
          setForm({
            ...form,
            [e.target.name]: e.target.value,
          });
        }
        break;
      default:
        break;
    }
  };

  return (
    <CambiarContraseña
      onChange={onChange}
      onClick={onClick}
      form={form}
      loading={loading}
      show={show}
      setShow={setShow}
    />
  );
};

export default ContraseñaController;
